document.addEventListener("DOMContentLoaded", function () {
  handleProductRecomendations();
});
function handleProductRecomendations() {
  const productRecommendationsSection = document.querySelector(
    "#would_like_too .product-recommendations"
  );

  const url = productRecommendationsSection.dataset.url;

  try {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          "#would_like_too .product-recommendations"
        );

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          activeSwiperPdp();
        }
      });
  } catch (error) {
    console.error(error);
  }
}

const activeSwiperPdp = () => {
  new Swiper("#would_like_too .swiper", {
    loop: true,
    slidesPerView: 1.3,
    spaceBetween: 24,
    navigation: {
      nextEl: "#would_like_too .swiper-button-next-custom",
      prevEl: "#would_like_too .swiper-button-prev-custom",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  });
};
